import React from 'react'
import { RankingStm, RankingStmProps } from './rankingStm'
import type { ItemPayload } from './Dnd/type'
import { Sortable } from './Dnd/Sortable'

export type SortableRankingStmProps = RankingStmProps & ItemPayload

export const SortableRankingStm = (p: SortableRankingStmProps) => {
    const { stm, sourceContainerId } = p
    return (
        <Sortable
            as={RankingStm}
            id={String(stm.valueKey)}
            data={{ sourceContainerId }}
            {...p}
        />
    )
}
